import {
  Badge,
  Button,
  CheckList,
  Dialog,
  Divider,
  Dropdown,
  DropdownRef,
  Empty,
  SearchBar,
  SearchBarRef,
  Selector,
} from 'antd-mobile';
import { useEffect, useMemo, useRef, useState } from 'react';
import styles from './index.module.scss';
import { isEmpty } from 'lodash-es';
import NoData from '@/assets/images/noData.png';
import { apiV2GgdMobileLocationListPost, batchOperateStatus, DeviceListResponse, getDeviceList } from '@/api/ggd';
import bgUp from './images/bgUp.png';
import lightOff from './images/lightOff.png';
import lightOn from './images/lightOn.png';
import { handleBatchOperate } from './util';
interface GetAreaListPostResponse {
  locationRemark: string;
  deviceNum: number;
}
const NewLightingControl = () => {
  const ref = useRef<DropdownRef>(null);
  const searchOwnerRef = useRef<SearchBarRef>(null);
  const searchZoneRef = useRef<SearchBarRef>(null);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [selectedDevice, setSelectedDevice] = useState<number[]>([]);
  const [selectedArea, setSelectedArea] = useState<string[]>([]);
  const [searchDeviceText, setSearchDeviceText] = useState('');
  const [searchAreaText, setSearchAreaText] = useState('');
  const [areaOp, setAreaOp] = useState<GetAreaListPostResponse[]>([]);
  const [deviceCount, setDeviceCount] = useState(12);
  const [devices, setDevices] = useState<DeviceListResponse[]>([]); //设备列表数据
  const [showControlHeader, setShowControlHeader] = useState(true);
  const lastScrollTop = useRef(0);

  // 使用 useMemo 计算当前显示的设备列表
  const displayedDevices = useMemo(() => {
    if (selectedDevice.length === 0) {
      return devices;
    }
    return devices.filter(device => selectedDevice.includes(device.deviceId!));
  }, [devices, selectedDevice]);

  // 获取设备列表的函数
  const fetchDevices = (useLocationRemarks: boolean = false, resetSelectedDevice: boolean = false) => {
    const params: any = {
      deviceName: searchDeviceText,
      page: 1,
      size: 500,
    };
    if (useLocationRemarks) {
      params.locationRemarks = selectedArea;
    }
    getDeviceList(params).then(res => {
      const deviceList = res.list || [];
      setDevices(deviceList);
      // 仅在初始化或指定时重置 selectedDevice
      // if (resetSelectedDevice) {
      //   setSelectedDevice(deviceList.map(item => item.deviceId!));
      // }
    });
  };

  useEffect(() => {
    // 获取区域列表
    apiV2GgdMobileLocationListPost({}).then(res => {
      const areaList = res.list || [];
      setAreaOp(areaList);
      // setSelectedArea(areaList.map(item => item.locationRemark!));
    });
    fetchDevices(false, true);
  }, []);

  // 模糊搜索过滤设备和区域选项
  const filteredDeviceItems = useMemo(() => {
    if (searchDeviceText) return devices.filter(item => item.name!.includes(searchDeviceText));
    else return devices;
  }, [devices, searchDeviceText]);
  const filteredAreaItems = useMemo(() => {
    if (searchAreaText) return areaOp.filter(item => item.locationRemark!.includes(searchAreaText));
    else return areaOp;
  }, [areaOp, searchAreaText]);

  // 更新设备数量
  useEffect(() => {
    setDeviceCount(displayedDevices.length);
  }, [displayedDevices]);

  // 处理全开操作
  const handleOpenAll = () => {
    Dialog.confirm({
      content: `确定要开启${deviceCount}个设备吗？`,
      onConfirm: async () => {
        await handleBatchOperate(
          displayedDevices.map(device => device.deviceId!),
          1,
          () => fetchDevices(true, false)
        );
      },
    });
  };

  // 处理全关操作
  const handleCloseAll = () => {
    Dialog.confirm({
      content: `确定要关闭${deviceCount}个设备吗？`,
      onConfirm: async () => {
        await handleBatchOperate(
          displayedDevices.map(device => device.deviceId!),
          0,
          () => fetchDevices(true, false)
        );
      },
    });
  };

  // 处理单个设备开关
  const handleToggleDevice = (deviceId: number, currentStatus: number) => {
    const action = currentStatus === 1 ? '关闭' : '打开';
    const newStatus = currentStatus === 1 ? 0 : 1;
    Dialog.confirm({
      content: `确定要${action}该设备吗？`,
      onConfirm: async () => {
        await handleBatchOperate([deviceId], newStatus, () => fetchDevices(true, false));
      },
    });
  };
  // 添加滚动监听
  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;
    const handleScroll = () => {
      const currentScrollTop = scrollContainer.scrollTop;
      if (currentScrollTop <= 100) {
        setShowControlHeader(true);
      } else if (currentScrollTop > lastScrollTop.current) {
        setShowControlHeader(false);
      } else {
        setShowControlHeader(true);
      }
      lastScrollTop.current = currentScrollTop;
    };
    scrollContainer.addEventListener('scroll', handleScroll);
    return () => scrollContainer.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <div className={styles.pageContainer}>
        <div className={styles.headerSpacer}>
          <div className={styles.fixedHeader}>
            <Dropdown
              ref={ref}
              onChange={key => {
                if (!key) {
                  setSearchAreaText('');
                  setSearchDeviceText('');
                  searchOwnerRef.current?.clear();
                  searchZoneRef.current?.clear();
                }
              }}
              style={{
                backgroundImage: `url(${bgUp})`,
                width: '100%',
                backgroundSize: '100%',
              }}
            >
              <Dropdown.Item key="zoneIdList" title="区域名称" className={styles.AreaOrDeviceText}>
                <div className={styles.dropdownPanel}>
                  <SearchBar placeholder="请输入区域名称" ref={searchZoneRef} onChange={setSearchAreaText} />
                  {!isEmpty(filteredAreaItems) ? (
                    <CheckList
                      value={selectedArea}
                      multiple
                      onChange={val => {
                        setSelectedArea(val as string[]);
                      }}
                    >
                      {filteredAreaItems?.map(item => (
                        <CheckList.Item key={item.locationRemark} value={item.locationRemark!}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <div className={styles.locationRemarks}>{item.locationRemark}&nbsp;</div>
                            <div className={styles.checkList}>{item.deviceNum}个设备</div>
                          </div>
                        </CheckList.Item>
                      ))}
                    </CheckList>
                  ) : (
                    <div className={styles.emptyState}>
                      <Empty image={NoData} description="暂无数据" />
                    </div>
                  )}
                  <div className={styles.actionBar}>
                    <Button
                      size="large"
                      onClick={() => {
                        setSelectedArea([]);
                      }}
                    >
                      重置
                    </Button>
                    <Button
                      size="large"
                      color="primary"
                      fill="solid"
                      onClick={() => {
                        //setSearchParams(prev => ({ ...prev, page: 1, zoneIdList: selectedArea }));
                        fetchDevices(true, true);
                        ref.current?.close();
                      }}
                    >
                      确定
                    </Button>
                  </div>
                </div>
              </Dropdown.Item>
              <Dropdown.Item key="ownerOrgId" title="设备名称" className={styles.AreaOrDeviceText}>
                <div className={styles.dropdownPanel}>
                  <SearchBar placeholder="请输入设备名称" ref={searchOwnerRef} onChange={setSearchDeviceText} />
                  {!isEmpty(filteredDeviceItems) ? (
                    <CheckList
                      value={selectedDevice}
                      multiple
                      onChange={val => {
                        setSelectedDevice(val as number[]);
                      }}
                    >
                      {filteredDeviceItems?.map(item => (
                        <CheckList.Item key={item.deviceId} value={item.deviceId!}>
                          {item.name}
                        </CheckList.Item>
                      ))}
                    </CheckList>
                  ) : (
                    <div className={styles.emptyState}>
                      <Empty image={NoData} description="暂无数据" />
                    </div>
                  )}
                  <div className={styles.actionBar}>
                    <Button
                      size="large"
                      onClick={() => {
                        setSelectedDevice([]);
                      }}
                    >
                      重置
                    </Button>
                    <Button
                      size="large"
                      color="primary"
                      fill="solid"
                      onClick={() => {
                        ref.current?.close();
                      }}
                    >
                      确定
                    </Button>
                  </div>
                </div>
              </Dropdown.Item>
            </Dropdown>
            <div style={{ margin: 0, border: '1px dashed #d9d9d9', width: '100%' }} />
          </div>
          <div className={`${styles.controlHeader} ${!showControlHeader ? styles.controlHeaderHidden : ''}`}>
            <div className={styles.deviceCount}>
              <span className={styles.label}>设备数:</span>
              <span className={styles.count}>&nbsp;{deviceCount}</span>
            </div>
            <div className={styles.controlButtons}>
              <Button className={styles.closeAllBtn} onClick={handleCloseAll}>
                全关
              </Button>
              <Button className={styles.openAllBtn} color="primary" fill="solid" onClick={handleOpenAll}>
                全开
              </Button>
            </div>
          </div>
        </div>
        <div className={styles.scrollableContent} ref={scrollContainerRef}>
          <div className={styles.deviceList}>
            {displayedDevices.map(item => (
              <div
                key={item.deviceId}
                className={styles.card}
                style={{ backgroundImage: `url(${item.status === 1 ? lightOn : lightOff})` }}
              >
                <span className={styles.deviceName}>{item.name}</span>
                <div className={styles.locationRemarks}>{item.locationRemark}</div>
                <div
                  className={item.status === 1 ? styles.powerOnIcon : styles.powerOffIcon}
                  onClick={() => handleToggleDevice(item.deviceId, item.status || 0)}
                />
              </div>
            ))}
          </div>
        </div>
        <div
          className={styles.scrollToTop}
          onClick={() => scrollContainerRef.current?.scrollTo({ top: 0, behavior: 'smooth' })}
        />
      </div>
    </>
  );
};

export default NewLightingControl;
